export default {
  props: {
    folderInfo: Object,
  },
};
